/* 🤖 this file was generated by svg-to-ts */
export const emperorIconPaperclip: {
  name: 'paperclip';
  data: string;
} = {
  name: 'paperclip',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><path d="M11 23c-2.9 0-5-2.32-5-5.5V9c0-4 2.79-7 6.5-7C16.2 2 19 5 19 9v7h-2V9c0-2.9-1.9-5-4.5-5C9.89 4 8 6.1 8 9v8.5c0 1.74.92 3.5 3 3.5 2.07 0 3-1.76 3-3.5V10c0-.61-.15-2-1.5-2C11.14 8 11 9.39 11 10v7H9v-7c0-2.393 1.407-4 3.5-4s3.5 1.6 3.5 4v7.5c0 3.18-2.11 5.5-5 5.5Z"/></svg>`
};
